import React, { useCallback, useEffect, useRef, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  deleteMeninggalkanTugas,
  postMeninggalkanTugas,
  showMeninggalkanTugas,
} from "../../api";
import { LayoutTable, LayoutThead } from "../../components/layouts/Table";
import {
  defaultFilterBulan,
  defaultFilterTahun,
  FilterBulan,
  FilterTahun,
  LayoutAddBtn,
} from "../../components/layouts/TopContent";
import { formatDate, formatDiffDate, saAlert, saConfirm } from "../../helpers";
import { titleState } from "../../storage/pages";
import NoDataPage from "../../components/pages/NoData";
import LoadingPage from "../../components/pages/Loading";
import { loginMasterState, userState } from "../../storage/auth";
import LayoutModal from "../../components/layouts/Modal";
import FormInput from "../../components/forms/Input";
import FormTextarea from "../../components/forms/Textarea";
import FormRadio from "../../components/forms/Radio";
import TableNew, { Tbody, Td, Th, Thead, Tr } from "../../components/layouts/TableNew";

const MeninggalkanTugas = () => {
  const setTitle = useSetRecoilState(titleState);
  const loginMaster = useRecoilValue(loginMasterState);

  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState();

  const [page] = useState("all");
  const [bulan, setBulan] = useState(defaultFilterBulan);
  const [tahun, setTahun] = useState(defaultFilterTahun);

  const fetchData = useCallback(async () => {
    try {
      const res = await showMeninggalkanTugas(
        page,
        `page=all&bulan=${bulan}&tahun=${tahun}`
      );
      console.log(res.data);
      if (res.data.meninggalkanTugas) {
        setItems(res.data.meninggalkanTugas);
        setIsLoaded(true);
      }
    } catch (err) {
      console.log(err.response);
    }
  }, [page, bulan, tahun]);

  useEffect(() => {
    fetchData();
    setTitle("Data Peminjaman Kamera");
  }, [fetchData, setTitle]);

  if (isLoaded) {
    return (
      <>
        <CreateMeninggalkanTugas onFetchData={fetchData} />
        <div className="row mb-2">
          <div className="col-md">
            <FilterBulan onChange={(res) => setBulan(res)} />
          </div>
          <div className="col-md">
            <FilterTahun onChange={(res) => setTahun(res)} />
          </div>
        </div>

        {items && items.length >= 1 ? (
          <TableNew>
            <Thead>
              <Tr className="text-center">
                <Th>No</Th>
                <Th>Nama Peminjam</Th>
                <Th>Keperluan</Th>
                <Th>Mulai</Th>
                <Th>Selesai</Th>
                <Th>Kelengkapan</Th>
                <Th>Kondisi Pinjam</Th>
                <Th>Kondisi Kembali</Th>
                <Th>Status</Th>
                <Th>Disetujui Oleh</Th>
                {/* <Th></Th> */}
              </Tr>
            </Thead>

            <Tbody>
              {items.map((i, index) => {
                return (
                  <Tr key={index}>
                    <Td className="text-center align-middle">
                      {index + 1}
                    </Td>

                    <Td className="align-middle">
                      {i.pegawai && i.pegawai.nama}
                    </Td>

                    <Td className="align-middle">
                      {i.keperluan}
                    </Td>

                    <Td className="text-nowrap text-center align-middle">
                      {formatDate(i.tanggal_mulai)}
                    </Td>

                    <Td className="text-nowrap text-center align-middle">
                      {formatDate(i.tanggal_selesai)}
                    </Td>

                    <Td className="align-middle">
                      {i.kelengkapan}
                    </Td>

                    <Td className="align-middle">
                      {i.kondisi_pinjam}
                    </Td>

                    <Td className="align-middle">
                      {i.kondisi_kembali}
                    </Td>

                    <Td className="text-center align-middle">
                      {i.status === null && (
                        <span className="fw-semibold text-dark">
                          Menunggu...
                        </span>
                      )}

                      {parseInt(i.status) === 1 && (
                        <span className="fw-semibold text-success-2">
                          Disetujui
                        </span>
                      )}

                      {parseInt(i.status) === 2 && (
                        <span className="fw-semibold text-danger-2">
                          Ditolak
                        </span>
                      )}
                    </Td>

                    <Td className="text-center align-middle">
                      {i.approver?.nama || "-"}
                    </Td>

                    {/* <Td className="text-center align-middle">
                      {i.status === null ? (
                        <DeletePeminjamanRuangan
                          id={i.id}
                          onFetchData={fetchData}
                        />
                      ) : (
                        <>
                          {loginMaster ? (
                            <DeletePeminjamanRuangan
                              id={i.id}
                              onFetchData={fetchData}
                            />
                          ) : (
                            <i className="fa fa-fw fa-circle-check text-success-2" />
                          )}
                        </>
                      )}
                    </Td> */}
                  </Tr>
                );
              })}
            </Tbody>
          </TableNew>
        ) : (
          <NoDataPage />
        )}
      </>
    );
  } else {
    return <LoadingPage />;
  }
};

const DeleteLembur = (props) => {
  const handleDelete = () => {
    saConfirm("warning", "Yakin hapus Meninggalkan Tugas ?").then((res) => {
      if (res.isConfirmed) {
        deleteMeninggalkanTugas(props.id).then((res) => {
          if (res.data && res.data.msg === "success") {
            props.onFetchData();
            saAlert("success", "Berhasil hapus data Meninggalkan Tugas !");
          }
        });
      }
    });
  };
  return (
    <button
      onClick={handleDelete}
      className="btn btn-sm btn-danger-2 py-0 px-1"
    >
      <i className="fa fa-fw fa-sm fa-trash-alt"/>
    </button>
  );
};

const CreateMeninggalkanTugas = (props) => {
  const user = useRecoilValue(userState);
  const tagForm = useRef(null);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({});
  const [formErrors, setFormErrors] = useState({});

  const handleClose = () => {
    setForm({});
    setFormErrors({});
    tagForm.current.reset();
    setModal(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    postMeninggalkanTugas(form)
      .then((res) => {
        if (res.data && res.data.msg === "success") {
          props.onFetchData();
          setForm({});
          setFormErrors({});
          tagForm.current.reset();
          setModal(false);
          saAlert("success", "Berhasil tambahkan data meninggalkan tugas !");
        }
      })
      .catch((err) => {
        let res = err.response;
        if (res) {
          if (res.status === 422) {
            setFormErrors(res.data.errors);
          }
        }
      });
  };

  return (
    <>
      <LayoutAddBtn
        onClick={() => setModal(true)}
        add="Ajukan Peminjaman Kamera"
      />

      <LayoutModal
        title="Ajukan Peminjaman Kamera"
        modal={modal}
        onClose={handleClose}
      >
        <form onSubmit={handleSubmit} ref={tagForm}>
          {/* <FormInput
            label="NIP"
            value={user.nip}
            readOnly={true}
          /> */}

          <FormInput
            label="Nama"
            value={`${user.nip} - ${user.nama}`}
            readOnly={true}
          />

          <FormInput
            label="Jabatan/Bagian"
            value={user.jabatan}
            readOnly={true}
          />

          <FormTextarea
            label="Keperluan Peminjaman"
            name="keperluan"
            onChange={(e) =>
              setForm((prevState) => ({
                ...prevState,
                [e.target.name]: e.target.value,
              }))
            }
            error={formErrors.keperluan}
          />

          <div className="row">
            <div className="col-md-6">
              <FormInput
                label="Tanggal Peminjaman"
                name="tanggal_mulai"
                type="datetime-local"
                onChange={(e) =>
                  setForm((prevState) => ({
                    ...prevState,
                    [e.target.name]: e.target.value,
                  }))
                }
                error={formErrors.tanggal_mulai}
              />
            </div>

            <div className="col-md-6">
              <FormInput
                label="Kembali Peminjaman"
                name="tanggal_selesai"
                type="datetime-local"
                onChange={(e) =>
                  setForm((prevState) => ({
                    ...prevState,
                    [e.target.name]: e.target.value,
                  }))
                }
                error={formErrors.tanggal_selesai}
              />
            </div>
          </div>

          <FormTextarea
            label="Kelengkapan"
            name="kelengkapan"
            onChange={(e) =>
              setForm((prevState) => ({
                ...prevState,
                [e.target.name]: e.target.value,
              }))
            }
            error={formErrors.kelengkapan}
          />

          <FormTextarea
            label="Kondisi Saat Dipinjam"
            name="kondisi_pinjam"
            onChange={(e) =>
              setForm((prevState) => ({
                ...prevState,
                [e.target.name]: e.target.value,
              }))
            }
            error={formErrors.kondisi_pinjam}
          />

          <hr />

          <p className="text-center mb-0">
            Approval peminjaman ruang meeting oleh
          </p>

          <p className="text-center fw-bold">
            Kepala Bagian SDM & Umum
          </p>

          <hr />

          <div className="btn-group">
            <button
              type="submit"
              className="btn btn-sm btn-success"
            >
              Ajukan
            </button>

            <button
              type="button"
              onClick={handleClose}
              className="btn btn-sm btn-secondary"
            >
              Tutup
            </button>
          </div>
        </form>
      </LayoutModal>
    </>
  );
};

export default MeninggalkanTugas;
